<div class="modal-header">
  <button type="button" class="close" ng-click="cancel()">&times;</button>
  <h3 class="modal-title">Configurações</h3>
</div>
<div class="modal-body">
  <form name="form">
    <div class="form-group">
      <label for="widget-title" class="control-label">Titulo</label>
      <input type="text" class="form-control" name="widgetTitle" ng-model="settings.result.title">
    </div>

    <div class="form-group">
      <label class="control-label">Propriedade</label>
      <ui-select ng-model="settings.result.dataModelOptions.propriedade" theme="bootstrap" id="propriedade"
        name="propriedade" append-to-body="true" ng-change="settings.getPluviometros()">
        <ui-select-match placeholder="Propriedade atual ({{$root.currentPropriedade.descricao}})">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn"
            ng-click="settings.clearPropriedade($event)">
            <i class="fa fa-remove true-clear-icon"></i>
          </span>
        </ui-select-match>
        <ui-select-choices
          repeat="propriedade in settings.result.data.propriedades | orderBy: 'descricao' | filter: $select.search track by propriedade.id">
          <span class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>

    <div class="form-group">
      <label class="control-label">
        Pluviômetro
      </label>
      <ui-select ng-model="settings.result.dataModelOptions.pluviometro" theme="bootstrap" id="pluviometro"
        name="pluviometro" append-to-body="true">
        <ui-select-match placeholder="Selecione o pluviômetro">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="settings.clearPluviometro($event)">
            <i class="fa fa-remove true-clear-icon"></i>
          </span>
        </ui-select-match>
        <ui-select-choices repeat="pluviometro in settings.result.dataModelOptions.propriedade.pluviometros | filter: $select.search">
          <span class="form-group" ng-bind-html="pluviometro.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="row">
      <div class="form-group col-xs-6">
        <label class="control-label">Data inicial</label>
        <div class="input-group">
          <input type="text" show-button-bar="false" class="form-control" uib-datepicker-popup="MMMM-yyyy"
            ng-model="settings.result.dataModelOptions.dataInicial" is-open="settings.datepickerInicialOpen"
            ng-change="settings.notInterval()" datepicker-options="{minMode: 'month',maxMode: 'month'}" />
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="settings.toggleInitialDatepicker()"><i
                class="glyphicon glyphicon-calendar"></i></button>
          </span>
          </span>
        </div>
      </div>

      <div class="form-group col-xs-6">
        <label class="control-label">Data final</label>
        <div class="input-group">
          <input type="text" class="form-control" uib-datepicker-popup="MMMM-yyyy"
            ng-model="settings.result.dataModelOptions.dataFinal" show-weeks="false"
            is-open="settings.datepickerFinalOpen" ng-change="settings.notInterval()"
            datepicker-options="{minMode: 'month',maxMode: 'month'}" />

          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="settings.toggleEndDatepicker()">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label padding-top-10" style="vertical-align: sub;">Intervalo: </label>
      <div class="btn-group" ng-repeat="days in [10, 15, 30]">
        <label for="{{days}}-days"
          ng-class="settings.result.dataModelOptions.daysInterval === days ? 'btn btn-primary' : 'btn btn-light'">
          {{days}} dias
          <input type="radio" name="age" ng-model="settings.result.dataModelOptions.daysInterval" ng-value="days"
            id="{{days}}-days" class="hidden">
        </label>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="settings.cancel()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="settings.ok()">OK</button>
</div>
